module.exports = __webpack_public_path__ + "static/media/tutorial-did-gain-xp-1-1.ac39730a.png";